if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.updateOptions();
        this.updateMasterId();
        this.setAvailability();
        
        // デバッグ用：スウォッチの状態を確認
        this.debugSwatches();
      }

      // 既存のコードはそのまま...

      debugSwatches() {
        console.log("Debugging swatches...");
        
        // スウォッチ要素を取得
        const swatchElements = document.querySelectorAll('.swatch');
        console.log(`Found ${swatchElements.length} swatch elements`);
        
        // 各スウォッチの状態を確認
        swatchElements.forEach((swatch, index) => {
          const style = window.getComputedStyle(swatch);
          const backgroundImage = style.backgroundImage;
          const backgroundColor = style.backgroundColor;
          
          console.log(`Swatch ${index + 1}:`);
          console.log(`- Background Image: ${backgroundImage}`);
          console.log(`- Background Color: ${backgroundColor}`);
          console.log(`- CSS Classes: ${swatch.className}`);
          console.log(`- Style attribute: ${swatch.getAttribute('style')}`);
          
          // 親要素のラベルからバリエーション値を取得
          const label = swatch.closest('label');
          if (label) {
            const hiddenText = label.querySelector('.visually-hidden');
            if (hiddenText) {
              console.log(`- Variant Value: ${hiddenText.textContent}`);
            }
          }
        });
      }
    }
  );
}
